interface ContactRequest {
  name: string;
  phone: string;
  email?: string;
  service?: string;
  message?: string;
  source: string;
  terms: boolean;
}

const failureMessage = "L’envoi n’a pas pu être confirmé. Vos informations sont conservées. Réessayez ou appelez le (438) 908-1143.";

class ContactRequestError extends Error {}

export async function submitContactRequest(payload: ContactRequest): Promise<void> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20_000);
  try {
    const response = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
    const result = await response.json().catch(() => null);
    if (!response.ok || result?.ok !== true) {
      throw new ContactRequestError(
        response.status === 400
          ? "Veuillez vérifier les champs du formulaire, puis réessayer. Vos informations sont conservées."
          : failureMessage,
      );
    }
  } catch (error) {
    if (error instanceof ContactRequestError) throw error;
    throw new ContactRequestError(failureMessage);
  } finally {
    clearTimeout(timeout);
  }
}

export function contactRequestErrorMessage(error: unknown): string {
  return error instanceof ContactRequestError ? error.message : failureMessage;
}

export function reportContactConversion(): void {
  try {
    const trackingWindow = window as Window & { gtag_report_conversion?: () => void };
    trackingWindow.gtag_report_conversion?.();
  } catch {
    // A blocked analytics script must not turn an accepted request into an error.
    console.warn("Suivi de conversion indisponible.");
  }
}